import { styled } from '@mui/material';

import { useEffect } from 'react';

import { Typography, Button } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';

import { usePricing } from '@app-velocity/config';

import { Plan } from '../Plan';

import { useCreateSubscriptionMutation } from '../../../../queries/useCreateSubscriptionMutation';
import { usePaymentPlansContext } from '../../../../context/usePaymentPlansContext';
import { CurrentPlan } from '../CurrentPlan';

const StyledPrice = styled(Typography)(({ theme }) => ({
  fontSize: 40,
  fontWeight: 700,
  lineHeight: 1,
  display: 'flex',
  alignItems: 'baseline',
  gap: theme.spacing(2),
  small: {
    fontSize: 13,
    fontWeight: 300,
  },
}));

export const StarterPlan = () => {
  const { t } = useI18n();
  const { getPlanPrice } = usePricing();

  const { subscribed, tier } = usePaymentPlansContext();
  const {
    mutate: startSubscription,
    isPending,
    data,
  } = useCreateSubscriptionMutation();

  const onClick = () => {
    startSubscription('regular');
  };

  useEffect(() => {
    if (!data) return;
    const { paymentUrl } = data;

    if (!paymentUrl) return;

    window.open(paymentUrl, '_blank');
  }, [data]);

  return (
    <Plan
      highlighted={!subscribed}
      name="payments:plans.starter.title"
      price={
        <StyledPrice>
          {getPlanPrice('regular')}
          <small>{t('payments:per_month')}</small>
        </StyledPrice>
      }
      description={[
        'payments:plans.starter.description.a',
        'payments:plans.starter.description.b',
        'payments:plans.starter.description.c',
        'payments:plans.starter.description.d',
        'payments:plans.starter.description.e',
        'payments:plans.starter.description.f',
      ]}
      action={
        subscribed && tier === 'REGULAR' ? (
          <CurrentPlan />
        ) : (
          <Button
            variant="contained"
            color={subscribed ? 'secondary' : 'primary'}
            onClick={onClick}
            disabled={isPending}
          >
            {subscribed && tier === 'PRO'
              ? t('payments:downgrade')
              : t('payments:upgrade')}
          </Button>
        )
      }
    />
  );
};
